import { axiosAjax } from '@app/src/config/axios';
import { isClientEnv } from '@app/src/utils/validations';

export const paymentService = {
  async post(json: any): Promise<any> {
    const userStorage = isClientEnv() && JSON.parse(localStorage.getItem('user'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${userStorage && userStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.post(
        process.env.API_PAYMENT,
        {...json, token: userStorage && userStorage.jwt},
        config
      );
      if (data.error) {
        throw new Error();
      }
      return data.data && data.data.length > 0 ? data.data[0] : {};
    } catch (e) {
      console.log('Error payment service');
      throw new Error(e);
    }
  }
}
